import React, {useEffect, useMemo, useRef, useState} from "react";
import Datatable from "components/Core/DataTable";
import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col, ModalHeader, ModalBody, Form, Button, ModalFooter, Modal
} from "reactstrap";
import Notify from "../lib/Utils/Alert";
import {MotionButton} from "../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import PurchaseOrder from "../lib/Core/Backend/Controllers/PurchaseOrder";
import PurchaseForm from "components/PurchaseOrder/PurchaseForm";
import GiftCardsFileForm from "components/PurchaseOrder/GiftCardsFileForm";
import Brand from "lib/Core/Backend/Controllers/Brand";
import CardType from "lib/Core/Backend/Controllers/CardType";
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import Supplier from "lib/Core/Backend/Controllers/Supplier";
import Purchaser from "lib/Core/Backend/Controllers/Purchaser";
import { SwipeableDrawer } from "@mui/material";
import OrderDetails from "components/PurchaseOrder/OrderDetails";
import ModalConfirm from "components/Purchaser/ModalConfirm";
import ModalConfirmInventory from "components/Purchaser/ModalConfirmInventory";
import $ from "jquery"
import useCatalogs from "hooks/useCatalogs";
import ModalUploadCSV from "components/Supplier/ModalUploadCSV";
import ModalUploadCSVTwo from "components/Supplier/ModalUploadCSVTwo";

const dollarUSLocale = Intl.NumberFormat('en-US', {
	style: "currency",
	currency: "USD",
});

const badges = {
	'1': `<span style="width: 100px" class="badge badge-pill text-white bg-wisteria">open</span>`,
	'2': `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`,
	'3': `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`,
	'4':  `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`,
	'5': `<span style="width: 100px" class="badge badge-pill text-white bg-warning">On hold</span>`,
	'6': `<span style="width: 100px" class="badge badge-pill text-white bg-info">API Low Funds</span>`,
	'7': `<span style="width: 100px" class="badge badge-pill text-white bg-info">Non API Low Funds</span>`,
	'8': `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">Incomplete</span>`,
	'11': `<span style="width: 100px" class="badge badge-pill text-white bg-warning">API Issue</span>`,
	'12': `<span style="width: 100px" class="badge badge-pill text-white bg-warning">CSV Mismatched</span>`,
}

const optionBadges = {
	'1': {
			label: `open`,
			value: 'open'
		},

	'2': {
			label: `in progress`,
			value: 'in progress'
		},
	'3': {
			label: `canceled`,
			value: 'canceled'
		},
	'4':  {
			label: `completed`,
			value: 'completed'
		},
	'5': {
			label: `On Hold`,
			value: 'On Hold'
		},
	'6': {
		label: `API Low Funds`,
		value: 'API Low Funds'
	},
	'7': {
		label: `Non API Low Funds`,
		value: 'Non API Low Funds'
	},
}

function PurchaseOrderView(props)
{
	const {token} = props;
	const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token),[token]);
	const supplierCtl = useMemo(() => new Supplier(token),[token]);
	const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
	const brandsCtl = useMemo(() => new Brand(token),[token]);
	const fileUploadCtl = useMemo(() => new FileUpload(token),[token]);
	const cardTypeCtl = useMemo(() => new CardType(token),[token]);

	const {currencies} = useCatalogs();
	
	const [giftCardsFile, setGiftCardsFile] = useState();
	const [giftCardsFileInfo, setGiftCardsFileInfo] = useState({});
	const [purchaseOrder, setPurchaseOrder] = useState({});
	const [purchaseOrderName, setPurchaseOrederName] = useState('');
	const [modal, setModal] = useState(false);
	const [modalGiftCardsFileForm, setModalGiftCardsFileForm] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [openDrawer, setOpenDrawer] = useState(false);
	const [modalUploadCSV, setModalUploadCSV] = useState(false);
	const [reload, setReload] = useState(true);

	const toggle = () => setModal(!modal);
	const toggleModalCSV = () => setModalUploadCSV(!modalUploadCSV)
	const toggleGiftCardsFileForm = () => setModalGiftCardsFileForm(!modalGiftCardsFileForm);
	const toggleConfirm = () => setConfirmModal(!confirmModal);
	const toggleDrawer = () => setOpenDrawer(!openDrawer);
	const triggerReload = () => setReload(!reload);

	const [activeOp, setActiveOp] = useState("Add New");
	const [operativeRow, setOperativeRow] = useState({});
	const [orderDetail, setOrderDetail] = useState();
	const [brands, setBrands] = useState([]);
	const [cardTypes, setCardTypes] = useState([]);
	const [uploadJson, setUploadJson] = useState(null);
	const[show,setShow]= useState(0);
	const[purchaserName,setPurchaserName] = useState(null);
	const [checkOrder, setCheckOrder] = useState(null);
	const [warningModal,setWarningModal] = useState(false);
	const [disabled,setDisabled] = useState(false)
	const [referenceValue,setReferenceValue] = useState('');
	const [dataLength, setDataLength] = useState(0);
	const [purchaserConfirmData,setPurchaserConfirmData] = useState([])
	const [modalConfirm, setModalConfirm] = useState(false);
	const [customerData,setCustomerData] = useState([]);
	const [selectedId,setSelectedId] = useState([]);
	const [preventManagerBatch,setPreventManageBatch] = useState(false)
    const [selectedIdTwo,setSelectedIdTwo] = useState([]);
	const [supplierLabel,setSupplierLabel] = useState('');
	const [brandId,setBrandId] = useState([])
	
	const [addCheckoutLoading, setAddCheckoutLoading]=useState(false)
	
   const modalConfirmToggle = () => setModalConfirm(!modalConfirm);
   const [termsofUseShow,setTermsofUseShow] = useState(false);
	const [callApi,setCallApi] = useState(false)
	const toggleWarning = () => setWarningModal(!warningModal);


	const table = useRef();
	const alert = useRef();

	const header = [
		{
			title: 'Date',
			data: 'createdAt',
			sortable: true,
			searchable: true,
			render: $.fn.dataTable.render.text(),
			renderForSelect: data => ({label: data, value: data}),
			type: 'date'
		},
		{title: 'Name', data: 'name', sortable: true, searchable: true, render: data => {
			if(data)
				return data;
			return 'Not available';
		}},
		{title:"Reference",data:'orderReference',searchable:true , render:(data)=>{
			if(data){
				return data
			}else{
				return ''
			}
		}},
		{title: 'Supplier', data: 'supplierName', searchable: true, render: $.fn.dataTable.render.text(), renderForSelect: data => ({label: data, value: data})},
		
		{title: 'Total Gift Card', data: 'subtotal', sortable: true, searchable: true, type: 'currency', width: '12%'},
		{title: 'Total Value', data: 'totalAmount', sortable: true, searchable: true, type: 'currency', width: '10%'},
		{title: 'Currency', data: 'currency', sortable: true, searchable: true,  width: '10%'},
		{title: 'Qty', data: 'totalQuantity', sortable: true, searchable: true, type: 'number', width: '8%'},
		{title: 'Status', data: 'status', sortable: true, searchable: true, render: (data) => {
			if(data){
				return badges[data] ?? 'Error'
			}
		},
		renderForSelect: data => {
			if(data){
				return optionBadges[data] ?? {
					label: 'error',
					value: 'error'
				}
			}
		}
	},
	{title: '', data: 'status', render: data => {
		if(data === '5'){
			return '<i class="text-info fas fa-upload ncentiva-upload-order" data-toggle="tooltip" data-placement="top" title="Upload order file"></i>'
		}
		return ''
	}},
	// {
	// 	title: '', data: 'status', render: data => {
	// 		if(data === '5'){
	// 			return '<i class="text-info fas fa-download ncentiva-download-order" data-toggle="tooltip" data-placement="top" title="Download order file"></i>'
	// 		}
	// 		return ''
	// 	}
	// },
	{
		title:'', data:'status', render: data=>{
			if(data === "1"|| data === "5"){
				return `<i class="text-danger fas fa-times ncentiva-cancel-order" data-toggle="tooltip" data-placement="top" title="Cancel upload"></i>`
 
			}
			return ''
		}
	}
	];

	function prepareToAdd()
	{
		toggle();
		setActiveOp("Add New");
		setPurchaseOrederName(`NCT-PO-S-${Math.floor(Math.random() * 100000)}`)
	}

	function finishOperation() {
		setDisabled(true)
		// e.preventDefault();
		// e.stopPropagation();
		
		if(dataLength === 0){
			Notify(alert,"warning","Add brands before save");
			return;
		}
		
		supplierCtl.createPurchaserOrderByName(purchaseOrderName,referenceValue, data => {
			if(data?.status === 403){
				toggleWarning();
				// toggle();
				setDisabled(false)
				return;
			}
			if (data && !data.error){
				triggerReload();
				// toggle();
				setReferenceValue('')
				Notify(alert, "success", "Purchase order created successfully");
				setTimeout(() => {
					setDisabled(false)	
				}, 1500);
				
			} else {
				Notify(alert, "danger", data.errorMessage);
				// toggle();
				setDisabled(false);
			}
		})
	}

	function removeCategory(row) {
		setOperativeRow(row);
		toggleConfirm();
	}

	function confirmDelete(){
		const row = operativeRow;
		setOperativeRow(null);
		row.remove().draw();
		toggleConfirm();
	}

	function handleModalAlerts(data) {
		Notify(alert, 'danger', data);
	}

	function uploadGiftCardsFile(e) {
		e.preventDefault();
		if (!!giftCardsFile)
		{
			fileUploadCtl.add(giftCardsFile, giftCardsFileInfo);
			toggleGiftCardsFileForm();
		}
	}

	const prepareDetails = (row) => {
		const rowData = row?.data()
		setOrderDetail(row.data());
		const hasNRT = rowData?.name?.includes('NRT');
        setCheckOrder(rowData?.name)
		setShow((prev)=>prev+1)
        if (hasNRT) {
            setPurchaserName(rowData?.name);
        }else{
			setPurchaserName(rowData?.id)
		}
		toggleDrawer();
	}

	const uploadFile = (row) => {
    let order = row.data()
    setUploadJson({
      name: order.name,
      quantity: order.totalQuantity
    });
    toggleModalCSV()
  }

  const fetallCustomer = () =>{
	purchaserCtl.purchaserAll((data)=>{
		if(data && !data.error){
		  
		  setCustomerData(data)
		  
		}
	  })
  }

  const orderList = () =>{
	supplierCtl.all(supplierData => {
		if(supplierData && !supplierData.error){
			purchaseOrderCtl.allbySourceTypeView(1, data => {
				if(data && !data.error){
					let purchaseOrders = data.map(order => {
						let orderCurrency = currencies.find(currency => currency.id === order.currencyId)
						const currencyFormat = new Intl.NumberFormat('en-US', {
							style: 'currency',
							currency: orderCurrency?.code ?? 'USD'
						})
						order.totalAmount = currencyFormat.format(order.totalAmount);
						order.subtotal = currencyFormat.format(order.subtotal)
						order.currency = orderCurrency?.code ?? 'N.A.';
						let supplier = supplierData.find(supplier => order.purchaseSourceId === supplier.id)
						order.supplierName = !!supplier ? supplier.name : 'Not available';
						order.status =  `${order.status}`
						return order;
					});
					table.current.dataTable.clear().rows.add(purchaseOrders)
					table.current.dataTable.search('').draw()

				} else {
					Notify(alert, 'danger', data.errorMessage ?? data.error)
				}
			});
		} else {
			Notify(alert, 'danger', supplierData.errorMessage ?? supplierData.error)
		}
	});
}
	useEffect(() => {
		brandsCtl.all(data => {
			if(data.error || data.errorMessage){
				Notify(alert, 'danger', data.errorMessage ?? data.error)
			} else {
				setBrands(data);
			}
		})

		cardTypeCtl.all(data => {
			if(data.error || data.errorMessage){
				Notify(alert, 'danger', data.errorMessage ?? data.error)
			} else {
				setCardTypes(data);
			}
		})

	},[brandsCtl, cardTypeCtl]);

	useEffect(() =>
	{
		if (!table.current){
			return
		}
		let callCount = 0;  
		const maxCalls = 5; 
		const delay = 3000; 

		const callOrderListWithDelay = () => {
			if (callCount < maxCalls) {
			callCount++;
			orderList();
			setTimeout(callOrderListWithDelay, delay + Math.floor(Math.random() * 3000)); 
			}
  };

  callOrderListWithDelay();
		
	}, [reload]);

	useEffect(() => {
		if (!callApi) return;
	
		const timeoutId = setTimeout(() => {
			orderList();
		}, 4000); // Call after 4 seconds (4000 ms)
	
		// Cleanup function to clear the timeout if component unmounts or if `callApi` changes
		return () => clearTimeout(timeoutId);
	
	}, [callApi]);

  const cancelOrder = (row) =>{
	
	let order = row.data();
	
	purchaseOrderCtl.cancelOrder(order.name, data => {
		if(data && data.error){
			Notify(alert ,'warning',data?.errorMessage)
		}else{
			Notify(alert, 'success', 'Order has been Canceled')
	        orderList()
		}
	})
}

const downloadFile = (data, filename) => {
	const csvData = convertToCSV(data);
	const url = window.URL.createObjectURL(new Blob([csvData]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

const convertToCSV = (data) => {
	const header = Object.keys(data[0]).join(',');
	const rows = data.map(obj => Object.values(obj).join(','));
	return `${header}\n${rows.join('\n')}`;
};

	const downloadOrder = (row) =>{
		let order = row.data();
        purchaseOrderCtl.downloadNonApiOrder(order.name, (data) => {
			if (data.error || data.errorMessage) {
			  Notify(alert, 'danger', data.errorMessage ?? data.error)
			} else {
			  downloadFile(data, `${order.name}.csv`);
			  Notify(alert, 'success', 'Order csv has been downloaded')
			}
		  })
	}

	const handleDataLengthChange = (length) => {
        setDataLength(length);
    };


	const modalOrderToConfirm = () => {
		const trimmedReferenceValue = referenceValue.trim();
		if(referenceValue.length === 0){
			Notify(alert, "warning", "referenceId can not be blank");
			setDisabled(false)
			return;
		}

		if (trimmedReferenceValue.length === 0) {
			Notify(alert, "warning", "Reference Id cannot be  just spaces");
			setDisabled(false);
			return;
		}
		if (purchaserConfirmData.length > 0) {
		  modalConfirmToggle();
		  setTermsofUseShow(true)
		  fetallCustomer()
		  toggle();
		} else {
		  Notify(alert, "danger", "Please Add brand before next");
		}
	  };

	  const onModalConfirmBack = () => {
		setReferenceValue('')
		modalConfirmToggle();
		toggle();
	  };
	  const confirmAddCheckOrder=()=>{
		setTimeout(()=>{
			setAddCheckoutLoading(false)
		},1500)
	  }
	  const onModalConfirmDone = () => {
		setAddCheckoutLoading(true)
		setReferenceValue('')
		modalConfirmToggle();
		finishOperation();
		if(selectedId.length === 0  && selectedIdTwo.length === 0 || (preventManagerBatch === true)){
			confirmAddCheckOrder()
			return;
		}

		let obj= {
			referenceId:referenceValue,
			brandIds:brandId,
			whiteListCustomerIds:selectedId,
			blackListCustomerIds:selectedIdTwo
		}

		supplierCtl.batchManage(obj,(data)=>{
			if(data && !data.error){
				confirmAddCheckOrder()
				}else{
				Notify(alert,"danger",data.errorMessage ?? data.error)
				confirmAddCheckOrder()
			}
		})
	  };

	return (<>
			<NotificationAlert ref={alert}/>
			<div className="content">
				<Row>
					<Col md="12">
						<Card>
							<CardHeader className="d-flex justify-content-between">
								<CardTitle tag="h5" className="list">Ncentiva Platform Purchase Orders List</CardTitle>
								<Row>
									<Col>
										<MotionButton initial={{ x: "-500%", opacity: 0 }} className="add_brand_purchase_order btn btn-primaryTwo" animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  onClick={prepareToAdd}>
											<i className="fas fa-shopping-cart" />{' '}Create new Purchase Order
										</MotionButton>
									</Col>
								</Row>
							</CardHeader>
							<CardBody>
								<div className="table-responsive">
								<Datatable
									id="orders"
									ref={table}
									columns={header}
									data={null}
									options={{
										order: [[0, 'desc']],
										saveState: false,
										dom: 'tip'
									}}
									addCustomButtons={[
										{
											callback: prepareDetails,
											name: 'purchaserDetails',
											icon: "fas fa-info-circle",
											style: 'padding: 5px 10px; background: transparent; font-size: 1.2rem',
											props: 'data-toggle="tooltip" data-placement="top" title="See Order details"'
									 	},
									]}
									addBtnsFromData={[{callback: uploadFile, selector: 'i.ncentiva-upload-order'}]}
									addCancelButton={[{callback:cancelOrder, selector:"i.ncentiva-cancel-order"}]}
									// addDownloadData={[{callback:downloadOrder,selector:"i.ncentiva-download-order"}]}
									enableSelectFilters={true}
								/>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>	
				<ModalUploadCSVTwo modal={modalUploadCSV} toggle={toggleModalCSV} uploadJson={uploadJson} token={token}  setCallApi={setCallApi} callApi={callApi}/>
				<Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="xl">
					<ModalHeader toggle={toggle} className="custom_header_colourTwo">{activeOp} Order</ModalHeader>
					<Form>
						<ModalBody>
							<PurchaseForm name={purchaseOrderName} token={token} openAlert={handleModalAlerts}
							 referenceValue={referenceValue} 
							 setReferenceValue={setReferenceValue}
							 setShowData={setPurchaserConfirmData}
							 onDataLengthChange={handleDataLengthChange}
							 supplierLabel={supplierLabel}
							 setSupplierLabel={setSupplierLabel}
							 brandId={brandId}
							 setBrandId={setBrandId}
							 />
						</ModalBody>
						<ModalFooter>
							<Button type="button" color="secondary" onClick={()=>{toggle();setReferenceValue('')}}>Cancel</Button>{' '}
							{/* {disabled === true ?  <Button type="submit" color="primary"  disabled>Save</Button>
							 :
							 <Button type="submit" color="primary" onClick={finishOperation}>Save</Button>
							} */}
							 <Button type="button" className="btn btn-primaryTwo" onClick={modalOrderToConfirm}>Next</Button>
						</ModalFooter>
					</Form>
				</Modal>
				<ModalConfirmInventory
          isOpen={modalConfirm}
          toggle={modalConfirmToggle}
          onBack={onModalConfirmBack}
          onConfirm={onModalConfirmDone}
          data={purchaserConfirmData}
          termsShow={termsofUseShow}
          token={token}
		  customerData={customerData}
		  selectedId={selectedId}
		  setSelectedId={setSelectedId}
		  selectedIdTwo={selectedIdTwo}
		  setSelectedIdTwo={setSelectedIdTwo}
		  supplierLabel={supplierLabel}
		  referenceValue={referenceValue}
		  preventManagerBatch={preventManagerBatch}
		  setPreventManageBatch={setPreventManageBatch} 
		  addCheckoutLoading={addCheckoutLoading}					
        />
				<Modal isOpen={modalGiftCardsFileForm} toggle={toggleGiftCardsFileForm} backdrop="static" centered={true} size="sm">
					<ModalHeader toggle={toggleGiftCardsFileForm} className="bg-info">{`Upload gift cards file for ${purchaseOrder.name}`}</ModalHeader>
					<Form>
						<ModalBody>
							<GiftCardsFileForm openAlert={handleModalAlerts} token={token} setFile={setGiftCardsFile} purchaseOrder={purchaseOrder} setFileInfo={setGiftCardsFileInfo}/>
						</ModalBody>
						<ModalFooter>
							<Button type="button" color="secondary" onClick={toggleGiftCardsFileForm}>Cancel</Button>{' '}
							<Button type="submit" color="primary" onClick={uploadGiftCardsFile}>Save</Button>
						</ModalFooter>
					</Form>
				</Modal>
				<Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static">
					<ModalHeader className="bg-warning" toggle={toggleConfirm}>Remove Order</ModalHeader>
					<ModalBody>
						<p className="card-just-text">
							Are you sure you want to remove the order "{!!operativeRow && !!operativeRow.data ? operativeRow.data().name : ""}"?
						</p>
					</ModalBody>
					<ModalFooter>
						<Button type="button" color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
						<Button type="button" color="primary" onClick={confirmDelete}>Yes</Button>
					</ModalFooter>
				</Modal>
			</div>
			<SwipeableDrawer
				anchor="right"
				open={openDrawer}
				onClose={toggleDrawer}
				onOpen={toggleDrawer}
      >
				<div style={{width: '60vw'}}>
					<OrderDetails order={orderDetail} token={token} brands={brands.result} cardTypes={cardTypes} progressName={purchaserName} checkOrder={checkOrder}
						progressShow={show} openDrawer={openDrawer} />
				</div>
			</SwipeableDrawer>
			<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
         </Modal>
		</>
	);
}

export default PurchaseOrderView;
